// Styles
import './products-carousel.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductsCarousel = (context) => {
  const productsCarouselSection = context.closest('.shopify-section');
  if (!productsCarouselSection) return;

  const swiperElement = productsCarouselSection.querySelector('.swiper');
  if (!swiperElement) return;

  const swiper = new Swiper(swiperElement, {
    slidesPerView: 3.03,
    spaceBetween: 4,
    navigation: {
      prevEl: (".products-carousel__heading__navigation__arrow.left"), 
      nextEl: (".products-carousel__heading__navigation__arrow.right")
    }
  });
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.products-carousel__container'),
    (el) => {
      window.dAgency.initProductsCarousel(el);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.products-carousel__container'),
      (el) => {
        window.dAgency.initProductsCarousel(el);
      },
    );
  });
}
